<template>
    <div id="container">
        <transition :name="transitionName" mode="out-in">
            <router-view :key="refreshKey" />
        </transition>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                refreshKey: 0,
                transitionName: '' // 默认使用桌面端动画
            }
        },
        computed: {
            isMobile() {
                return window.innerWidth <= 768
            }
        },
        watch: {
            '$route'(to, from) {
                // 根据设备类型设置不同的过渡动画
                if (this.isMobile) {
                    // 移动端使用滑动动画
                    const toIndex = to.meta && to.meta.index !== undefined ? to.meta.index : 0
                    const fromIndex = from.meta && from.meta.index !== undefined ? from.meta.index : 0
                    this.transitionName = toIndex > fromIndex ? 'slide-left' : 'slide-right'
                } else {
                    // 桌面端使用淡入淡出动画
                    this.transitionName = ''
                }
            }
        },
        mounted() {
            // 监听全局刷新事件
            this.$root.$on('refresh-page', this.handleRefresh)
        },
        beforeDestroy() {
            // 组件销毁前移除事件监听
            this.$root.$off('refresh-page', this.handleRefresh)
        },
        methods: {
            handleRefresh() {
                this.refreshKey += 1
            }
        }
    }
</script>

<style scoped>
/* 容器样式 */
#container {
    position: relative;
    min-height: calc(100vh - 85px);
    background: transparent;
}

/* 移动端允许滚动但隐藏横向滚动条 */
@media (max-width: 768px) {
    #container {
        overflow-y: auto;
        overflow-x: hidden;
    }
}

/* 桌面端过渡动画 */
@media (min-width: 769px) {
    #container {
        overflow: hidden;
    }
    
    /* 页面淡入淡出动画 */
    .page-enter-active, .page-leave-active {
        transition: all var(--animation-duration-normal) var(--animation-easing-smooth);
    }
    
    .page-enter {
        opacity: 0;
        transform: translateY(20px) scale(0.98);
    }
    
    .page-leave-to {
        opacity: 0;
        transform: translateY(-10px) scale(1.02);
    }
}

/* 移动端过渡动画 */
@media (max-width: 768px) {
    .slide-left-enter-active, .slide-left-leave-active,
    .slide-right-enter-active, .slide-right-leave-active {
        transition: all 0.15s cubic-bezier(0.165, 0.84, 0.44, 1);
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        right: 0;
    }

    /* 向左滑动（前进） */
    .slide-left-enter {
        transform: translateX(100%);
        opacity: 0;
    }

    .slide-left-leave-to {
        transform: translateX(-20%) scale(0.95);
        opacity: 0.3;
    }

    /* 向右滑动（后退） */
    .slide-right-enter {
        transform: translateX(-20%) scale(0.95);
        opacity: 0.3;
    }

    .slide-right-leave-to {
        transform: translateX(100%);
        opacity: 0;
    }
}
</style>
